<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <!-- <b-card>
        <b-tabs pills>
          <b-tab lazy active>
            <template #title>
              <feather-icon icon="DollarSignIcon" size="16" class="mr-0 mr-sm-50" />
              <span class="d-none d-sm-inline">Ventas</span>
            </template>
            <venta />
          </b-tab>

          <b-tab lazy>
            <template #title>
              <feather-icon icon="ShoppingCartIcon" size="16" class="mr-0 mr-sm-50" />
              <span class="d-none d-sm-inline">Compras</span>
            </template>
            <compra />
          </b-tab>
        </b-tabs>
      </b-card> -->
      <b-tabs pills>
          <b-tab lazy active>
            <template #title>
              <feather-icon icon="DollarSignIcon" size="16" class="mr-0 mr-sm-50" />
              <span class="d-none d-sm-inline">Ventas</span>
            </template>
            <venta />
          </b-tab>
          <b-tab lazy>
            <template #title>
              <feather-icon icon="ShoppingCartIcon" size="16" class="mr-0 mr-sm-50" />
              <span class="d-none d-sm-inline">Compras</span>
            </template>
            <compra />
          </b-tab>
        </b-tabs>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import venta from './venta.vue'
import compra from './compra.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
    }
  },
  components:{
    venta,
    compra
  }
}
</script>

<style></style>
